import {useFormik} from 'formik';
import * as Yup from 'yup';
import {useState} from 'react';
import {AxiosError} from 'axios';
import {useFundraiser} from '../../../entities';
import {ProjectTransferFormData, ProjectTransferDTO} from '../../../entities';

interface UseProjectTransferFormProps {
  fundraiserId: string;
  setOpen: (open: boolean) => void;
  onSuccess?: () => void;
}

export const useProjectTransferForm = ({fundraiserId, setOpen, onSuccess}: UseProjectTransferFormProps) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [formDataForConfirm, setFormDataForConfirm] = useState<ProjectTransferDTO | null>(null);
  const {transferFromProjectMutation} = useFundraiser({id: fundraiserId});

  const validationSchema = Yup.object({
    amount: Yup.number()
      .typeError('Должно быть числом')
      .required('Сумма обязательна')
      .positive('Сумма должна быть положительной'),
  });

  const onSubmit = async (values: ProjectTransferFormData) => {
    const transferData: ProjectTransferDTO = {
      amount: parseFloat(values.amount),
    };

    setFormDataForConfirm(transferData);
    setShowConfirmModal(true);
  };

  const handleConfirmTransfer = async () => {
    if (!formDataForConfirm) return;

    try {
      await transferFromProjectMutation.mutateAsync(formDataForConfirm);
      setShowConfirmModal(false);
      setOpen(false);
      formik.resetForm();
      onSuccess?.();
    } catch (error) {
      console.error('Ошибка при внесении средств:', error);
    }
  };

  const formik = useFormik<ProjectTransferFormData>({
    initialValues: {
      amount: '',
    },
    validationSchema,
    onSubmit,
  });

  return {
    ...formik,
    setFieldTouched: formik.setFieldTouched,
    isLoading: transferFromProjectMutation.isPending,
    submitError: transferFromProjectMutation.error
      ? (transferFromProjectMutation.error as AxiosError).response?.data
      : undefined,
    showConfirmModal,
    setShowConfirmModal,
    formDataForConfirm,
    handleConfirmTransfer,
    submitForm: () => formik.handleSubmit(),
  };
};
